<template>
      <el-dialog
              title="授权"
              :visible.sync="dialogVisible"
              top="50px"
              width="80%">
          <iframe style="width: 100%;height: 500px;margin-top: 10px;margin-top: -10px;" :src="dataForm.url"></iframe>
      </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
        dialogVisible:false,
      dataForm: {
        url: ''
      }
    }
  },
  methods: {
      init() {
          debugger
          this.visible = true
          this.dialogVisible=true;
      }
  }
}
</script>
